import {ApiRequestConfig} from '@shared/helpers/api'
import {qs} from '@shared/helpers/queryString'

import getApi, {getCommonBaseUrl} from '@web/helpers/api'

import {
    PaymoneyAndRewardResponse,
    RewardPointWithVoucherReloadParams,
    RewardPointWithVoucherReloadResponse,
} from '../interfaces'

const api = getApi(getCommonBaseUrl())

/** 적립 포인트, 페이머니 잔액 조회 */
async function fetchPaymoneyAndReward(config?: ApiRequestConfig): Promise<PaymoneyAndRewardResponse> {
    const {
        data: {result},
    } = await api.get('/point/all/reload', config)

    return result
}

async function fetchRewardPointWithVoucher({
    type,
    include,
    payChannel,
    merchantNos,
    middleCategoryIds,
    serviceSeq,
    bcCode,
    bcMerchantNo,
}: RewardPointWithVoucherReloadParams): Promise<RewardPointWithVoucherReloadResponse> {
    const {
        data: {result},
    } = await api.get(`/point/reward/reload`, {
        params: {
            type,
            payChannel,
            include,
            ...(payChannel === 'C1' || payChannel === 'C2' ? {merchantNos} : {}),
            ...(payChannel === 'C2' ? {middleCategoryIds} : {}),
            ...(payChannel === 'DICON' ? {serviceSeq} : {}),
            ...(payChannel === 'BC' ? {bcCode, bcMerchantNo} : {}),
        },
        paramsSerializer: (params) => {
            return qs.stringify(params, {arrayFormat: 'none'})
        },
    })

    return result
}

export {fetchPaymoneyAndReward, fetchRewardPointWithVoucher}
